import events from '../Content/calEvents.json';

export const calEvents = events;
export type CalEventId = keyof typeof events;
export const isCalEventId = (id: string): id is CalEventId => Object.prototype.hasOwnProperty.call(events, id);
export const calEventIds = Object.keys(events) as CalEventId[];
export const bookingPath = (id: CalEventId) => `/booking?package=${encodeURIComponent(id)}`;
